/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { HtmlHeadInclude } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import { IDobbiesNoScriptProps } from './dobbies-no-script.props.autogenerated';

export interface IDobbiesNoScriptViewProps extends IDobbiesNoScriptProps<{}> {}

/**
 *
 * DobbiesNoScript component
 * @extends {React.PureComponent<IDobbiesNoScriptProps<IDobbiesNoScriptData>>}
 */
class DobbiesNoScript extends React.PureComponent<IDobbiesNoScriptProps<{}>> {
    public render(): JSX.Element | null {
        return (
            <HtmlHeadInclude>
                <noscript data-load-point='bodyBegin'>{this.props.config.scriptSource}</noscript>
            </HtmlHeadInclude>
        );
    }
}

export default DobbiesNoScript;
